var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"num-spinner"},[_c('i',{staticClass:"icon-minus minu-btn"}),_vm._v(" "),_c('input',{attrs:{"type":"text","readonly":"readonly","value":"1"}}),_vm._v(" "),_c('i',{staticClass:"icon-add add-btn"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f6fa0c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/numSpinner/numSpinner.vue
// module id = oFXR
// module chunks = 33